import  {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { useLoginTeacherMutation } from '../../slices/teachers/teachersApiSlice';
import { setTeacherCredentials } from '../../slices/teachers/authTeacherSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [email, setEmail] = useState("ana22@gmail.com");
    const [password, setPassword] = useState("anaSmith22");

    const [loginTeacher, { isLoading }] = useLoginTeacherMutation();

    const { teacherInfo } = useSelector((state) => state.authTeacher);
    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if (teacherInfo) {
            navigate('/teachernewquestions');
        }
    },[navigate, teacherInfo]);

    useEffect(() => {
        if (studentInfo) {
            navigate('/studentnewanswer');
        }
    },[navigate, studentInfo]);
        
    const submitHandler = async (e) => {
        e.preventDefault()
        if (email == '') { toast.error('Please enter  email'); return; } 
        if (password == '') { toast.error('Please enter  password'); return; }
        try {
            const res = await loginTeacher({ email, password }).unwrap();
            dispatch(setTeacherCredentials({ ...res }));
            navigate('/teachernewquestions');
        } catch (err) { 
            toast.error(err?.data?.message || err.error.message);
        }        
    }

    return (
        <div className="bg-default">
            <div className="main-content" >
                <div className=" mt--7 loginResponsive">
                    {/* <div className="header  bg-gradient-primary py-6 py-lg-8 pt-lg-7"> */}
                    <div className="header  bg-gradient-primary py-9 py-lg-9 pt-lg-7 headerLog">
                        <div className="container-fluid">
                            <div className="header-body text-center mb-7">
                                <div className="row justify-content-center">
                                    <div className="col-xl-5 col-lg-6 col-md-8 px-5">
                                        <h1 className="text-white loginLogo2">
                                            <img src="../../assets/img/log4.png" className="imgResponsive"  style={{ marginLeft: "1%", width: "13%"}}  />
                                            <br /><a href="/teacherlogin" className="text-light loginLogo">Ask to Learn</a>
                                        </h1>
                                        <p className="text-lead text-white loginText">Teacher Login</p>
                                         {/* <br /><br /><br /><br /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container  mt--9 pb--9 ">
                        <div className="row justify-content-center ">
                            <div className="col-lg-5 col-md-7 ">
                                <div className="card border-0 mb-0 headerLog2 ">
                                    {/* <div className="card-header bg-transparent pb-4"> */}
                                        {/* <div className="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div> */}
                                        {/* <div className="btn-wrapper text-center">
                                            <a href="#" className="btn btn-neutral btn-icon">
                                            <span className="btn-inner--icon"><img src="../../assets/img/icons/common/facebook.png" /></span>
                                            <span className="btn-inner--text">Facebook</span>
                                            </a>
                                            <a href="#" className="btn btn-neutral btn-icon">
                                            <span className="btn-inner--icon"><img src="../../assets/img/icons/common/google.svg" /></span>
                                            <span className="btn-inner--text">Google</span>
                                            </a>
                                        </div> */}
                                    {/* </div> */}
                                    <div className="card-body px-lg-5 py-lg-5">
                                        <div className="text-center text-muted mb-4">
                                            <small>Sign in with credentials</small>
                                        </div>
                                        <form role="form" onSubmit={submitHandler}>
                                            <div className="form-group mb-3">
                                                <div className="input-group input-group-merge input-group-alternative">
                                                    <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text"><i className="ni ni-email-83"></i></span>
                                                    </div>
                                                    <input 
                                                        className="form-control emailForm" 
                                                        placeholder=" Email" 
                                                        type="email" 
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-merge input-group-alternative">
                                                    <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text"><i className="ni ni-lock-circle-open"></i></span>
                                                    </div>
                                                    <input 
                                                        className="form-control emailForm" 
                                                        placeholder=" Password" 
                                                        type="password"  
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="custom-control custom-control-alternative custom-checkbox">
                                                {/* <input className="custom-control-input" id=" customCheckLogin" type="checkbox"  /> */}
                                                <input className="custom-control-input" id=" customCheckLogin" type="checkbox" checked="check" />
                                                <label className="custom-control-label" htmlFor=" customCheckLogin">
                                                    <span className="text-muted">click sign in for demo</span>
                                                </label>
                                            </div><br />
                                            <div className="text-center">
                                                <button type="submit" className="btn btn-primary my-4 border border-light rounded-pill">Sign in</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <Link to={'/studentlogin'} className="text-light">
                                            <small>Student Login</small>
                                        </Link>
                                    </div>
                                    <div className="col-6 text-right">
                                        <Link to={'/teacherregister'} className="text-light">
                                            <small>Create new Teacher account</small>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="py-5" id="footer-main">
                    <div className="container">
                        <div className="row align-items-center justify-content-xl-between">
                            <div className="col-xl-6">
                            <div className="copyright text-center text-xl-left text-muted">
                                <a  className="font-weight-bold ml-1 text-white" target="_blank">  Ask to Learn</a>
                            </div>
                            </div>
                            <div className="col-xl-6">
                            <ul className="nav nav-footer justify-content-center justify-content-xl-end">
                                <li className="nav-item">
                                <a  className="nav-link text-white" target="_blank">
                                    Categories
                                    </a>
                                </li>
                                <li className="nav-item">
                                <a  className="nav-link text-white" target="_blank">About Us</a>
                                </li>
                                <li className="nav-item">
                                <a  className="nav-link text-white" target="_blank">Blog</a>
                                </li>
                                <li className="nav-item">
                                <a  className="nav-link text-white" target="_blank">License</a>
                                </li>
                            </ul>
                            </div><br /><br /><br />
                            <br className='brResponsive' />
                            <br className='brResponsive' />
                            <br className='brResponsive' />
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}

export default TeacherLogin